export default __webpack_public_path__ + "static/media/11.a6365c43.png";